import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"
import { get, pick } from "lodash"
import { AppNavigation } from "containers/AppNavigation"
import { PageCard, PageCardContent } from "components/card"
import { NavigationControl } from "components/kioskHorizontal/navigation"
import { useGeoLocation } from "providers/geolocation"
import { useVenue } from "providers/venue"

import { LiveTrafficMap } from "extensions/live-traffic/components/Map"
import { useExtension } from "hooks/extension/useExtension"

import { EXTENSION_NAME } from "extensions/em-live-traffic/constant"

export const LiveTrafficKioskHPage = ({ Layout = Box }) => {
  const { extensionConfig } = useExtension()
  const { dataLoaded } = useVenue()
  const { userLocation } = useGeoLocation()

  const locationLatLng = useMemo(() => {
    try {
      if (!userLocation) return null
      const [lng, lat] = get(userLocation, "geometry.coordinates", [])
      return { lat, lng }
    } catch (error) {
      return null
    }
  }, [userLocation])

  const emLiveTrafficConfig = useMemo(
    () => extensionConfig?.[EXTENSION_NAME]?.options,
    [extensionConfig]
  )

  const options = useMemo(
    () => pick(emLiveTrafficConfig, ["center", "staleTime", "zoom"]),
    [emLiveTrafficConfig]
  )

  const theme = useTheme()
  const { styleOverrides: bannerStyleOverrides = {} } =
    theme.components[`AppBanner`] || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}
  const { root: bannerRoot } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides
  return (
    <Layout
      aside={
        <PageCard>
          <Box sx={wrapper}>
            <Box sx={bannerRoot}></Box>
            <Box sx={body}>
              <AppNavigation />
            </Box>
            <Box sx={footer}>
              <NavigationControl />
            </Box>
          </Box>
        </PageCard>
      }
    >
      <PageCard>
        <PageCardContent>
          {dataLoaded ? (
            <LiveTrafficMap key={"ive"} {...options} marker={locationLatLng} />
          ) : null}
        </PageCardContent>
      </PageCard>
    </Layout>
  )
}
